import { render, staticRenderFns } from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=template&id=da8b96d8&scoped=true&"
import script from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingRiskAcceptanceV3.vue?vue&type=style&index=0&id=da8b96d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8b96d8",
  null
  
)

export default component.exports